import { render, staticRenderFns } from "./AdvertisementPage.vue?vue&type=template&id=291e8754&scoped=true&"
import script from "./AdvertisementPage.vue?vue&type=script&lang=js&"
export * from "./AdvertisementPage.vue?vue&type=script&lang=js&"
import style1 from "./AdvertisementPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291e8754",
  null
  
)

export default component.exports